import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import { StorageMap } from '@ngx-pwa/local-storage';
//import { StorageService, Util } from '@phdsoft/common';
import { Base64 } from 'js-base64';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GLOBAL, ROUTES, SESSION_STORAGE } from './constants';
import { recordLogoutReason, stripQuery } from './utils/logout-diagnostics';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

  constructor(
    //public storageService: StorageService,
    private readonly router: Router,
    // private storeMap: StorageMap
    ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let modified: HttpRequest<any> = null;

    if (req.body as FormData) {
      modified = req.clone({ setHeaders: { 'Content-Type': GLOBAL.MULTIPART_FORM_DATA } });
      modified = req.clone({ setHeaders: { Accept: GLOBAL.MULTIPART_FORM_DATA } });
    } else {
      modified = req.clone({ setHeaders: { 'Content-Type': GLOBAL.APPLICATION_TYPE_JSON } });
    }

    modified = modified.clone({ setHeaders: { 'Access-Control-Allow-Origin': '*' } });

    const token = localStorage.getItem(SESSION_STORAGE.TOKEN)
    //const token = sessionStorage[SESSION_STORAGE.TOKEN];
    if (token
      && modified.url.indexOf('https://phdc4dtest.blob.core.windows.net/') < 0
      && modified.url.indexOf('https://phdc4ddev.blob.core.windows.net/' ) < 0
      && modified.url.indexOf('https://phdc4dstage.blob.core.windows.net/') < 0
      && modified.url.indexOf('https://phdc4dprod.blob.core.windows.net/') < 0
    ){
      modified = modified.clone({
          setHeaders: {
              Authorization: `Bearer ${token}`
          }
      });
    }

    return next.handle(modified).pipe(
      catchError(
        (err, caught) => {
          if (err.status === 401){
            // Logout diagnostics (temporary, QA): the request whose 401 sends this tab to the login page.
            recordLogoutReason('interceptor: 401', {
              method: modified.method,
              url: stripQuery(modified.url),
              sentAuthorization: modified.headers.has('Authorization'),
              statusText: err.statusText,
            });
            this.handleAuthError();
            return of(err);
          }
          if (err.status === 403){
            this.router.navigateByUrl(ROUTES.DIGITALTWIN_GEO);
          }
          throw err;
        }
      )
    )
  }
  handleAuthError() {
    //this.storageService.removeItem(SESSION_STORAGE.TOKEN);
    this.router.navigateByUrl(ROUTES.LOGIN);
  }
}
